import {call, put, takeEvery} from 'redux-saga/effects';
import {api} from "../../api/api";
import {cardsActions} from "../cards.slice";
import {PayloadAction} from "@reduxjs/toolkit";

function* deleteSaga(action: PayloadAction<string>) {
    yield call(api.deleteCard, {
        cardId: action.payload,
    });

    yield put(cardsActions.deleteFromStore(action.payload));
}

export function* deleteCardSaga() {
    yield takeEvery(cardsActions.deleteCard.type, deleteSaga);
}
